<template>
  <div class="plainCont">
    <div class="topCont">
      <div style="margin-bottom: 12px" class="returnBtn" @click="returnHome">
        <i class="iconfont  icon-return"></i>返回
      </div>
      <div style="margin-bottom: 12px;color: #c2c2c2">
        当前选择专业为：{{ facultyData.faculty_name }}--{{ facultyData.major_name }}--{{ facultyData.grade_name }}
      </div>
      <div style="margin-bottom: 12px">
        <el-button size="small" type="primary" style="margin-right: 10px" @click="importVisible = true">Excel批量添加
        </el-button>
        <el-button size="small" @click="downloadTemplate">下载Excel示例</el-button>
      </div>
      <div class="addTitleBox">
        <span style="margin-right: 5px">标题名称:</span>
        <el-input size="medium" v-model="inputTitle" style="margin-right: 16px;width:350px"/>
      </div>
      <div class="addTitleBox">
        <span style="margin-right: 5px">授予学位:</span>
        <el-select size="medium" v-model="inputDegree" style="margin-right: 16px;width:350px">
          <el-option disabled value="">请选择毕业授予学位</el-option>
          <el-option value="哲学学士学位">哲学学士学位</el-option>
          <el-option value="经济学学士学位">经济学学士学位</el-option>
          <el-option value="法学学士学位">法学学士学位</el-option>
          <el-option value="教育学学士学位">教育学学士学位</el-option>
          <el-option value="文学学士学位">文学学士学位</el-option>
          <el-option value="历史学学士学位">历史学学士学位</el-option>
          <el-option value="理学学士学位">理学学士学位</el-option>
          <el-option value="工学学士学位">工学学士学位</el-option>
          <el-option value="农学学士学位">农学学士学位</el-option>
          <el-option value="医学学士学位">医学学士学位</el-option>
          <el-option value="管理学学士学位">管理学学士学位</el-option>
          <el-option value="艺术学学士学位">艺术学学士学位</el-option>
        </el-select>
      </div>
      <div class="addTitleBox">
        <span style="margin-right: 5px">培养目标:</span>
        <!--        <textarea v-model="inputTrainTarget" style="margin-right: 16px;width:700px;height:75px;overflow:scroll;"></textarea>-->
        <el-input
          type="textarea"
          :rows="4"
          v-model="inputTrainTarget"
          style="width:650px"
        >
        </el-input>
      </div>
      <div class="addTitleBox">
        <span style="margin-right: 5px">毕业要求:</span>
        <!--        <textarea v-model="inputGraduReq" style="margin-right: 16px;width:700px;height:75px;overflow:scroll;"></textarea>-->
        <el-input
          type="textarea"
          :rows="4"
          v-model="inputGraduReq"
          style="margin-right: 20px;width:650px"
        >
        </el-input>
        <div>
          <el-button size="medium" type="primary" style="margin-right: 7px" @click="saveTitle">保存</el-button>
        </div>
      </div>
      <div class="addCourseBox">
        <span style="margin-right: 5px">内容:</span>
        <el-button size="medium" type="primary" @click="addOrEditCourse('add')">添加</el-button>
      </div>
    </div>
    <div class="middleCont">
      <div class="tableCont">
        <el-table
          v-loading="loading"
          ref="table"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="headRowClass"
          :cell-style="rowClass"
          :max-height="tableHeight"
        >
          <el-table-column
            label="序号"
            prop="id"
            width="150"
            align="center"
          />
          <el-table-column
            label="课程号"
            prop="course_code"
            width="200"
            align="center"
          />
          <el-table-column
            label="课程名称"
            prop="course_title"
            align="center"
          />
          <el-table-column
            label="学分"
            prop="credit"
            width="150"
            align="center"
          />
          <el-table-column
            label="周学时"
            prop="week_hours"
            width="150"
            align="center"
          />
          <el-table-column
            label="年级"
            prop="grade"
            width="150"
            align="center"
          />
          <el-table-column
            label="学期"
            prop="semester"
            width="150"
            align="center"
          />
          <el-table-column
            label="类型"
            prop="course_type"
            align="center"
          />
          <el-table-column prop="operate" label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="addOrEditCourse('edit',scope.row)">编辑</el-button>
              <el-button type="text" size="medium" @click="deleteCourse(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bottomCont">
      <!--      <el-button size="small" type="primary" style="margin-right: 7px">取消</el-button>-->
      <el-button size="small" type="primary" style="margin-right: 7px" @click="coursePrev"
                 :disabled="inputTitle.trim().length === 0||tableData.length===0">预览
      </el-button>
      <el-button size="small" type="primary" @click="publishCourse"
                 :disabled="inputTitle.trim().length === 0||tableData.length===0">发布
      </el-button>
    </div>
    <el-dialog :title="type==='add'?'添加课程':'编辑课程'" :visible.sync="addVisible" width="36%%">
      <div class="dialog-form">
        <el-form
          ref="editRuleForm"
          :model="form1"
          :rules="rules"
          size="small"
          label-suffix=":"
          label-width="100px"
        >
          <el-form-item label="课程号" prop="name1">
            <el-input
              size="medium"
              placeholder="请输入课程号"
              v-model="form1.course_code"
              style="width: 88%"
            ></el-input>
          </el-form-item>
          <el-form-item label="课程名称" prop="name1">
            <el-input
              size="medium"
              placeholder="请输入课程名称"
              v-model="form1.course_title"
              style="width: 88%"
            ></el-input>
          </el-form-item>
          <el-form-item label="学分" prop="name1">
            <el-input
              size="medium"
              placeholder="请输入学分"
              v-model="form1.credit"
              style="width: 88%"
            ></el-input>
          </el-form-item>
          <el-form-item label="周学时" prop="name1">
            <el-input
              size="medium"
              placeholder="请输入周学时"
              v-model="form1.week_hours"
              style="width: 88%"
            ></el-input>
          </el-form-item>
          <el-form-item label="年级" prop="name1">
            <el-select v-model="form1.grade" placeholder="请选择年级" style="width: 70%">
              <el-option
                v-for="(item,index) in grade_info"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学期" prop="name1">
            <el-select v-model="form1.semester" placeholder="请选择学期" style="width: 70%">
              <el-option
                v-for="(item,index) in semester_info"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程类型" prop="name1">
            <el-select v-model="form1.course_type" placeholder="请选择课程类型" style="width: 70%">
              <el-option
                v-for="(value,key) in course_type"
                :key="key"
                :label="value"
                :value="value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click.native="addOrEditOkLodash"
                   style="margin-right: 8px">确 定</el-button>
        <el-button size="medium" @click="addVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="批量添加"
      :visible.sync="importVisible"
      width="35%"
      height="350px"
    >
      <div class="upload-box">
        <el-upload
          class="upload-demo"
          ref="upload"
          action="/api/academic-planning/import-study-planning"
          :on-error="handleError"
          :on-success="handleSuccess"
          :file-list="fileList"
          :auto-upload="false"
          :multiple="false"
          :limit="1"
          :data="{'grade_id':facultyData.id}"
          :headers="headerData"
        >
          <el-input
            placeholder="请选择整理好的Excel"
            :disabled="true"
            style="width: 300px"
            size="medium"
          />
          <el-button size="medium" type="primary">选择文件</el-button>
          <!--          <el-button size="medium" slot="trigger" type="primary">选取文件</el-button>-->
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="submitUpload">确 定</el-button>
        <el-button size="medium" @click="importVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import moment from "moment";
import trainMangeApi from '../../../api/trainMange'
import getCookie from "../../../utils/cookie";
import {debounce} from 'lodash'

export default {
  name: 'home',
  components: {},
  computed: {
    ...mapState('trainMange', ['facultyData'])
  },
  watch: {
    // inputTitle: {
    //   deep: true,
    //   handler: function (newVal, oldVal) {
    //     this.titleStatus = true
    //     if (!newVal || newVal.trim().length === 0) {
    //       this.titleStatus = false
    //     }
    //   }
    // },
    // inputDegree: {
    //   deep: true,
    //   handler: function (newVal) {
    //     this.degreeStatus = true
    //     if (!newVal || newVal.trim().length === 0) {
    //       this.degreeStatus = false
    //     }
    //   }
    // },
    // inputTrainTarget: {
    //   deep: true,
    //   handler: function (newVal) {
    //     this.targetStatus = true
    //     if (!newVal || newVal.trim().length === 0) {
    //       this.targetStatus = false
    //     }
    //   }
    // },
    // inputGraduReq: {
    //   deep: true,
    //   handler: function (newVal) {
    //     this.graduStatus = true
    //     if (!newVal || newVal.trim().length === 0) {
    //       this.graduStatus = false
    //     }
    //   }
    // }
  },
  data() {
    return {
      loading: false,
      pageData: {
        page: 1,
        total: 1,
        search: "", //搜索
      }, //分页
      tableData: [], //表格
      addVisible: false,
      inputTitle: '',
      inputDegree: '',
      inputTrainTarget: '',
      inputGraduReq: '',
      titleStatus: false,  //标题保存状态
      degreeStatus: false,  //学位保存状态
      targetStatus: false,  //培养目标保存状态
      graduStatus: false,   //毕业要求保存状态
      form1: {
        grade_id: '',
        // title: '',
        course_code: '',
        course_title: '',
        credit: '',
        week_hours: '',
        grade: '',
        semester: '',
        course_type: '',
      },
      rules: {
        course_title: [
          {required: true, message: "请输入课程名称", trigger: "blur"},
        ],
      },
      importVisible: false,
      fileList: [],
      headerData: {
        token: getCookie('_token'),
      },
      course_type: {},  //课程类型下拉框
      grade_info: [],//年级信息下拉框,
      semester_info: [],//学期信息下拉框
      type: 'add',
      tableHeight: '650'
    }
  },
  mounted() {
    // console.log(1111, this.facultyData)
    this.getAcademicPlanning({grade_id: this.facultyData.id})
    this.getSelectData()
    this.getRelationTitle({id: this.facultyData.id})
    this.$nextTick(function () {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 90;
      let self = this;

      window.onresize = function () {
        self.tableHeight = window.innerHeight - self.$refs.table.$el.offsetTop - 90
      }
    })
  },
  methods: {
    formatterDate(row) {
      return moment(parseInt(row.updated_at) * 1000).format('YYYY-MM-DD hh:mm:ss')
    },
    async getRelationTitle(params) {
      await trainMangeApi.getRelationTitle(params).then(res => {
        if (res && res.code === 10000) {
          this.inputTitle = res.data.title
          this.inputDegree = res.data.degree
          this.inputTrainTarget = res.data.train_target
          this.inputGraduReq = res.data.gradu_req
          this.titleStatus = res.data.title && res.data.title.trim().length !== 0;
          this.degreeStatus = !!(res.data.degree && res.data.degree.trim().length !== 0);
          this.targetStatus = !!(res.data.train_target && res.data.train_target.trim().length !== 0);
          this.graduStatus = !!(res.data.gradu_req && res.data.gradu_req.trim().length !== 0);
        }
      })
    },
    getAcademicPlanning(params) {
      trainMangeApi.getAcademicPlanning(params).then(res => {
        if (res && res.code === 10000) {
          this.tableData = res.data
        }
      })
    },
    getSelectData() {
      trainMangeApi.academicPlanningSelect().then(res => {
        if (res && res.code === 10000) {
          this.course_type = res.data.course_type
          this.grade_info = res.data.grade_info
          this.semester_info = res.data.semester_info
        }
      })
    },
    addOrEditCourse(type, data) {
      this.type = type
      if (type === 'add') {
        this.form1 = {
          grade_id: '',
          course_code: '',
          course_title: '',
          credit: '',
          week_hours: '',
          grade: '',
          semester: '',
          course_type: '',
        }
      } else if (type === 'edit') {
        this.form1 = {
          id: data.id,
          grade_id: data['grade_id'],
          course_code: data['course_code'],
          course_title: data['course_title'],
          credit: data['credit'],
          week_hours: data['week_hours'],
          grade: data['grade'],
          semester: data['semester'],
          course_type: data['course_type'],
        }
      }
      this.addVisible = true
    },
    addOrEditOkLodash:
      debounce(function () {
        this.addOrEditOk()
      }, 500),
    addOrEditOk() {
      // this.form1.title = this.inputTitle
      if (this.type === 'add') {
        this.form1.grade_id = this.facultyData.id
        this.formData = {
          'grade_id[0]': this.facultyData.id,
          'course_code[0]': this.form1.course_code,
          'course_title[0]': this.form1.course_title,
          'credit[0]': this.form1.credit,
          'week_hours[0]': this.form1.week_hours,
          'grade[0]': this.form1.grade,
          'semester[0]': this.form1.semester,
          'course_type[0]': this.form1.course_type,
        }
        trainMangeApi.addAcademicPlanning(this.formData).then(res => {
          if (res && res.code === 10000) {
            this.addVisible = false
            this.$message({message: '添加成功', type: "success"})
            this.getAcademicPlanning({grade_id: this.facultyData.id})
          } else {
            this.$message({message: res.message, type: "error"})
          }
        })
      } else if (this.type === 'edit') {
        trainMangeApi.editAcademicPlanning(this.form1).then(res => {
          if (res && res.code === 10000) {
            this.addVisible = false
            this.$message({message: '修改成功', type: "success"})
            this.getAcademicPlanning({grade_id: this.facultyData.id})
          } else {
            this.$message({message: res.message, type: "error"})
          }
        })
      }
    },
    deleteCourse(id) {
      trainMangeApi.deleteAcademicPlanning({id: id}).then(res => {
        if (res && res.code === 10000) {
          this.$message({message: '删除成功', type: "success"})
          this.getAcademicPlanning({grade_id: this.facultyData.id})
        }
      })
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleError() {
      this.$message.error("上传失败");
    },
    handleSuccess(res) {
      if (res && res.code === 10000) {
        this.$message({message: '批量添加成功', type: "success"})
        this.getAcademicPlanning({grade_id: this.facultyData.id})
        this.importVisible = false
      } else {
        this.$message({message: res.message, type: "error"})
      }
      this.$emit('next')
    },
    downloadTemplate() {
      window.location.href = '/api/academic-planning/download'
    },
    saveTitle() {
      if (!this.inputTitle || this.inputTitle && this.inputTitle.trim().length === 0) {
        this.$message({message: '标题不能为空', type: "warning"})
        return
      }
      if (!this.inputDegree || this.inputDegree && this.inputDegree.trim().length === 0) {
        this.$message({message: '学位不能为空', type: "warning"})
        return
      }
      if (!this.inputTrainTarget || this.inputTrainTarget && this.inputTrainTarget.trim().length === 0) {
        this.$message({message: '培养目标不能为空', type: "warning"})
        return
      }
      if (!this.inputGraduReq || this.inputGraduReq && this.inputGraduReq.trim().length === 0) {
        this.$message({message: '毕业要求不能为空', type: "warning"})
        return
      }
      this.titleStatus = true
      this.degreeStatus = true
      this.targetStatus = true
      this.graduStatus = true
      trainMangeApi.editRelationTitle({
        id: this.facultyData.id,
        title: this.inputTitle,
        degree: this.inputDegree,
        train_target: this.inputTrainTarget,
        gradu_req: this.inputGraduReq
      }).then(res => {
        if (res && res.code === 10000) {
          this.$message({message: res.message, type: "success"})
        }
      })
    },
    coursePrev() {
      // this.getRelationTitle({id: this.facultyData.id})
      if (!this.titleStatus) {
        this.$message({message: '请保存标题后再预览', type: "warning"})
        return
      }
      if (this.titleStatus && (!this.inputTitle || this.inputTitle && this.inputTitle.trim().length === 0)) {
        this.$message({message: '标题不能为空', type: "warning"})
        return
      }

      if (!this.degreeStatus) {
        this.$message({message: '请保存授予学位后再预览', type: "warning"})
        return
      }
      if (this.degreeStatus && (!this.inputDegree || this.inputDegree && this.inputDegree.trim().length === 0)) {
        this.$message({message: '学位不能为空', type: "warning"})
        return
      }


      if (!this.targetStatus) {
        this.$message({message: '请保存培养目标后再预览', type: "warning"})
        return
      }
      if (this.targetStatus && (!this.inputTrainTarget || this.inputTrainTarget && this.inputTrainTarget.trim().length === 0)) {
        this.$message({message: '培养目标不能为空', type: "warning"})
        return
      }


      if (!this.graduStatus) {
        this.$message({message: '请保存毕业要求后再预览', type: "warning"})
        return
      }
      if (this.graduStatus && (!this.inputGraduReq || this.inputGraduReq && this.inputGraduReq.trim().length === 0)) {
        this.$message({message: '毕业要求不能为空', type: "warning"})
        return
      }
      // this.$router.push('coursePreview')
      const routeUrl = this.$router.resolve({
        path: "/coursePreview",
      });
      window.open(routeUrl.href, '_blank')
    },
    publishCourse() {
      if (!this.titleStatus) {
        this.$message({message: '请保存标题后再发布', type: "warning"})
        return
      }
      if (this.titleStatus && (!this.inputTitle || this.inputTitle && this.inputTitle.trim().length === 0)) {
        this.$message({message: '标题不能为空', type: "warning"})
        return
      }

      if (!this.degreeStatus) {
        this.$message({message: '请保存授予学位后再发布', type: "warning"})
        return
      }
      if (this.degreeStatus && (!this.inputDegree || this.inputDegree && this.inputDegree.trim().length === 0)) {
        this.$message({message: '学位不能为空', type: "warning"})
        return
      }


      if (!this.targetStatus) {
        this.$message({message: '请保存培养目标后再发布', type: "warning"})
        return
      }
      if (this.targetStatus && (!this.inputTrainTarget || this.inputTrainTarget && this.inputTrainTarget.trim().length === 0)) {
        this.$message({message: '培养目标不能为空', type: "warning"})
        return
      }


      if (!this.graduStatus) {
        this.$message({message: '请保存毕业要求后再发布', type: "warning"})
        return
      }
      if (this.graduStatus && (!this.inputGraduReq || this.inputGraduReq && this.inputGraduReq.trim().length === 0)) {
        this.$message({message: '毕业要求不能为空', type: "warning"})
        return
      }
      trainMangeApi.releaseAcademicPlanning({grade_id: this.facultyData.id}).then(res => {
        if (res && res.code === 10000) {
          this.$message({message: '发布成功', type: "success"})
          this.$router.push('trainProgram')
        }
      })
    },
    returnHome() {
      this.$router.go(-1)
    },
    headRowClass({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return "background:rgba(215,215,215,0.6)"
      }
    },
    rowClass({row, column, rowIndex, columnIndex}) {
      if (rowIndex % 2 === 0) {
        return "background:rgb(242,242,242,0.5)"
      }
    },
  },

}
</script>

<style lang="less" scoped>

.plainCont {
  height: 100%;
  padding: 15px 20px;
  box-sizing: border-box;

  .topCont {
    margin-bottom: 20px;

    .returnBtn {
      cursor: pointer;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 17px;

      .icon-return {
        font-size: 17px;
        margin-right: 6px;
        color: #949494;
      }
    }

    .addTitleBox {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      span {
        //display: inline-block;
        width: 85px;
        text-align: right;

        &::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }
      }
    }

    .addCourseBox {
      span {
        //display: inline-block;
        width: 85px;
        text-align: right;

        &::before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
        }
      }

      display: flex;
      align-items: center;
    }
  }

  .middleCont {
    .tableCont {
      margin-bottom: 15px;
    }
  }

  .bottomCont {
    float: right;
  }
}

/deep/ .el-dialog {
  .upload-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 30px;
  }

  .el-dialog__footer {
    text-align: center;
  }


}

</style>
